import React from "react";
import { Reveal } from "../helpers";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const FAQS = [
  { q: "What services does Paramarsh Tech offer?", a: "We're a full-stack digital and AI partner. We design and build high-performance websites, e-commerce platforms and custom web apps, native and cross-platform mobile applications, and intelligent automation systems including AI chatbots, call automation and workflow automation. On top of that, we provide end-to-end digital consultation — from requirement gathering and technology selection to a clear roadmap and deployment. Whether you're starting from scratch or scaling an existing product, we cover the entire journey." },
  { q: "How long does a typical project take?", a: "It depends entirely on the scope and complexity of what you're building. A polished landing page can go live in a matter of days, while a full-featured web or mobile platform usually takes a few weeks of focused work. AI and automation systems vary based on the integrations and data involved. Before we begin, we break the project into clear milestones and share a realistic timeline, so you always know exactly what to expect and when." },
  { q: "Do you provide ongoing support after launch?", a: "Absolutely — launch is just the beginning. We offer dedicated support and maintenance plans that keep your product secure, fast and up to date long after it goes live. That includes monitoring, bug fixes, performance tuning, security patches and feature enhancements as your business grows. You get a committed team that stays with you, so you're never left figuring things out on your own." },
  { q: "Can you integrate AI into my existing product?", a: "Yes, this is one of our core specialities. We can add AI chatbots, smart automations and intelligent workflows directly into your current systems with minimal disruption to what's already working. We start by understanding your existing architecture and business goals, then integrate the right AI capabilities in a way that's reliable, scalable and genuinely useful — not just a gimmick. The result is a product that works smarter and saves you real time and cost." },
  { q: "How do we get started?", a: "Getting started is simple and completely commitment-free. Just reach out through the contact form below or book a consultation, and tell us a little about your idea or challenge. We'll schedule a free discovery call to understand your goals, budget and timeline, then propose the best path forward with a clear plan. From there, we handle the heavy lifting while keeping you involved at every important step." },
];

export default function FAQ() {
  return (
    <section className="relative py-28 md:py-32">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="font-mono text-xs tracking-[0.3em] text-brand-orange uppercase mb-4">/ FAQ</p>
          <h2 className="font-heading font-semibold text-3xl sm:text-4xl lg:text-5xl tracking-tight mb-12">
            Questions, <span className="text-gradient-orange">answered</span>
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-white/10">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-heading font-medium text-lg text-white hover:text-brand-orange hover:no-underline py-6"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="font-body text-brand-sec leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
